export const ArrowLeftIcon = () => (
  <svg fill="none" height="100%" viewBox="0 0 50 73" width="100%" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.706955 40.1441L49.3 72.3V63.0171L8.34895 36.649V36.3801L49.3 10.0091V0.726074L0.699951 32.8791L0.706955 40.1441Z"
      fill="white"
    />
  </svg>
);
